export default function () {
  return {
    name: "Insomnia Follow Up (Trial)",
    description:
      "We can help you find out if medication might help with your insomnia",
    version: "2023061401",
    service_code: "INSOMNIA_FOLLOW_UP_TRIAL",
    live: true,
    staged: true,
    questions: [
      {
        title: "Which insomnia treatments helped since your last visit?",
        description:
          "Check all that apply. This helps us better customize your insomnia plan.",
        type: "checkbox",
        code: "interventions-which-helped",
        choices: [
          {
            label: "Prescription sleep medication",
          },
          {
            label: "Over the counter sleep supplements",
          },
          {
            label: "Sleep log tracking",
          },
          {
            label: "Practicing healthy sleep habits",
          },
          // {
          //   label: "Sleep coaching via text messaging",
          // },
          {
            label: "Meditation / Breathing Exercises",
          },
          {
            label: "Other",
            children: [
              {
                title: "Tell us more...",
                description: "",
                code: "interventions-which-helped-other",
                type: "textarea",
              },
            ],
          },
        ],
      },

      {
        title: "Which treatments were the least helpful?",
        description:
          "Tell us what didn't work. This helps us better customize your insomnia plan.",
        type: "checkbox",
        code: "interventions-not-helpful",
        choices: [
          {
            label: "Prescription sleep medication",
            // children: [
            //   {
            //     title: "Tell us more...",
            //     description: "",
            //     code: "interventions-not-helpful-prescription-medication-why",
            //     type: "textarea",
            //   },
            // ],
          },
          {
            label: "Over the counter sleep medication",
            children: [
              {
                title: "Tell us more...",
                description: "",
                code: "interventions-not-helpful-otc-medication-why",
                type: "textarea",
              },
            ],
          },
          {
            label: "Sleep log tracking",
            children: [
              {
                title: "Tell us more...",
                description: "",
                code: "interventions-not-helpful-sleep-log-why",
                type: "textarea",
              },
            ],
          },
          {
            label: "Practicing healthy sleep habits",
            children: [
              {
                title: "Tell us more...",
                description: "",
                code: "interventions-not-helpful-sleep-habits-why",
                type: "textarea",
              },
            ],
          },
          // {
          //   label: "Sleep coaching via text messaging",
          //   children: [
          //     {
          //       title: "Tell us more...",
          //       description: "",
          //       code: "interventions-not-helpful-sleep-coaching-why",
          //       type: "textarea",
          //     },
          //   ],
          // },
          {
            label: "Meditation / Breathing Exercises",
            children: [
              {
                title: "Tell us more...",
                description: "",
                code: "interventions-not-helpful-meditation-why",
                type: "textarea",
              },
            ],
          },
          {
            label: "Other",
            children: [
              {
                title: "Tell us more...",
                description: "",
                code: "interventions-not-helpful-other",
                type: "textarea",
              },
            ],
          },
          {
            label: "None of the above",
            silent: true,
          },
        ],
      },

      {
        title:
          "Did you experience any of the following side effects with your sleep medication?",
        description:
          "This information helps us find the right medication with the fewest side effects for you.",
        type: "checkbox",
        code: "insomnia-side-effects",
        choices: [
          {
            label: "Morning headaches?",
            children: [
              {
                title:
                  "Which drug(s) and what dosage(s) caused you to have morning headaches?",
                description: "",
                code: "insomnia-drug-dosage-morning-headache",
                type: "textarea",
              },
              {
                title:
                  "Could you describe the morning headaches in more detail? Did they go away?",
                description: "",
                code: "insomnia-drug-dosage-morning-headache-detail",
                type: "textarea",
              },
            ],
          },
          {
            label: "Nasal congestion?",
            children: [
              {
                title:
                  "Which drug(s) and what dosage(s) caused you to have nasal congestion?",
                description: "",
                code: "insomnia-drug-dosage-nasal-congestion",
                type: "textarea",
              },
              {
                title:
                  "Could you describe the nasal congestion in more detail? How bad was it?",
                description: "",
                code: "insomnia-drug-dosage-nasal-congestion-detail",
                type: "textarea",
              },
            ],
          },
          {
            label: "Lower extremity swelling in your legs?",
            children: [
              {
                title:
                  "Which drug(s) and what dosage(s) caused you to have swelling?",
                description: "",
                code: "insomnia-drug-dosage-lower-extremity-swelling",
                type: "textarea",
              },
              {
                title:
                  "Could you describe the lower extremity swelling in more detail? What time of day did it happen? Did it go away?",
                description: "",
                code: "insomnia-drug-dosage-lower-extremity-swelling-detail",
                type: "textarea",
              },
            ],
          },
          {
            label: "Significant oral dryness in your mouth?",
            children: [
              {
                title:
                  "Which drug(s) and what dosage(s) caused you to have oral dryness?",
                description: "",
                code: "insomnia-drug-dosage-oral-dryness",
                type: "textarea",
              },
              {
                title:
                  "Could you describe the oral dryness in more detail? How bad was it? Did it go away?",
                description: "",
                code: "insomnia-drug-dosage-oral-dryness-detail",
                type: "textarea",
              },
            ],
          },
          {
            label: "Lightheadedness, dizziness, balance problems? Any falls?",
            children: [
              {
                title:
                  "Which drug(s) and what dosage(s) caused you to have lightheadedness or balance problems?",
                description: "",
                code: "insomnia-drug-dosage-light-headedness",
                type: "textarea",
              },
              {
                title:
                  "Could you describe what happened in more detail? How did you feel?",
                description: "",
                code: "insomnia-drug-dosage-light-headedness-detail",
                type: "textarea",
              },
            ],
          },
          {
            label: "Morning Grogginess the next day?",
            children: [
              {
                title:
                  "Which drug(s) and what dosage(s) caused you to have morning grogginess?",
                description: "",
                code: "insomnia-drug-dosage-morning-grogginess",
                type: "textarea",
              },
              {
                title:
                  "Could you describe the grogginess in more detail? Did anything help? Did it go away?",
                description: "",
                code: "insomnia-drug-dosage-morning-grogginess-detail",
                type: "textarea",
              },
            ],
          },
          {
            label: "Mental fog or inability to focus during the day?",
            children: [
              {
                title:
                  "Which drug(s) and what dosage(s) caused you to have mental fog?",
                description: "",
                code: "insomnia-drug-dosage-mental-fog",
                type: "textarea",
              },
              {
                title:
                  "Could you describe the mental fog in more detail? Did anything help? Did it go away?",
                description: "",
                code: "insomnia-drug-dosage-mental-fog-detail",
                type: "textarea",
              },
            ],
          },
          {
            label: "None of the above",
            silent: true,
          },
        ],
      },

      {
        title: "Did any of the following occur with your sleep medication?",
        description:
          "This information is important for us to understand how medication affected you.",
        type: "checkbox",
        code: "insomnia-safety-sedation",
        choices: [
          {
            label:
              "Waking up in the middle of the night even after taking sleep medication?",
            children: [
              {
                title:
                  "Which drug(s) and what dosage(s) caused you to wake up?",
                description: "",
                code: "insomnia-drug-dosage-middle-night-wake-up",
                type: "textarea",
              },
            ],
          },

          {
            label:
              "Sleepiness or near misses while driving at any time in the day?",
            children: [
              {
                title:
                  "Which drug(s) and what dosage(s) caused you to feel sleepy while driving?",
                description: "",
                code: "insomnia-drug-dosage-driving-sleepiness",
                type: "textarea",
              },
            ],
          },
          {
            label: "Significant morning drowsiness?",
            children: [
              {
                title:
                  "Which drug(s) and what dosage(s) caused you to feel morning drowsiness?",
                description: "",
                code: "insomnia-drug-dosage-morning-drowsiness",
                type: "textarea",
              },
            ],
          },
          {
            label: "Worsening sleepiness during the day?",
            children: [
              {
                title:
                  "Which drug(s) and what dosage(s) caused you to feel worsening sleepiness during the day?",
                description: "",
                code: "insomnia-drug-dosage-worsening-sleepiness",
                type: "textarea",
              },
            ],
          },
          {
            label: "Other?",
            children: [
              {
                title:
                  "Tell us more. Which drug(s) and what dosage(s) caused issues?",
                description: "",
                code: "insomnia-drug-dosage-other",
                type: "textarea",
              },
            ],
          },
          {
            label: "None of the above",
            silent: true,
          },
        ],
      },

      {
        title:
          "Which medication and dose did you find the most helpful? How did it help?",
        code: "insomnia-medication-dose-most-helpful",
        description:
          "Please be as detailed as possible. How did you feel the next day? This helps us personalize and find the best medication for you.",
        type: "textarea",
      },

      {
        title:
          "Would you like to continue with the same sleep medication or try something different?",
        description:
          "If you'd like to try something different, what isn't working with the current medication? What are you hoping a new medication will do?",
        type: "textarea",
        code: "insomnia-medication-continue-different",
      },

      {
        title: "How well were you able to follow healthly sleep habits?",
        description:
          "Nobody is perfect with their sleep habits. Tell us what worked and what didn't. We'll work with you to find your best night's rest",
        type: "textarea",
        code: "insomnia-healthy-sleep-habits-how-well",
      },

      // {
      //   title: "How much did Kick's sleep habit suggestions help?",
      //   description: "On a scale of 1 (least helpful) to 5 (most helpful)",
      //   type: "radio",
      //   code: "insomnia-sleep-habit-helpfulness-rating",
      //   choices: [
      //     {
      //       label: "1",
      //     },
      //     {
      //       label: "2",
      //     },
      //     {
      //       label: "3",
      //     },
      //     {
      //       label: "4",
      //     },
      //     {
      //       label: "5",
      //     },
      //   ],
      // },

      // {
      //   title:
      //     "What worked or didn't work with the sleep habit recommendations and sleep log?",
      //   description:
      //     "Patients that combine sleep medication with good sleep habits and tracking are the most successful. What worked and didn't work for you?",
      //   type: "textarea",
      //   code: "insomnia-what-worked-sleep-habit-log",
      // },

      {
        title: "Any other sleep issues you're struggling with?",
        description:
          "Are there any other issues you feel like we could help with?",
        type: "radio",
        code: "insomnia-sleep-struggles",
        choices: [
          {
            label: "Yes",
            children: [
              {
                title:
                  "Help us understand what you're still struggling with...",
                code: "insomnia-sleep-struggles-detail",
                type: "textarea",
              },
            ],
          },
          {
            label: "No, we can move on",
            silent: true,
          },
        ],
      },

      {
        title:
          "Anything else you would like your doctor or the care team to know?",
        description:
          "Before we wrap up, any final things you'd like to tell your doctor and care team? Feel free to ask questions as well.",

        type: "radio",
        choices: [
          {
            label: "Yes",
            children: [
              {
                title: "What would you like to tell your doctor?",
                code: "insomnia-doctor-let-know",
                type: "textarea",
              },
            ],
          },
          {
            label: "No, we can move on",
            silent: true,
          },
        ],
      },
    ],
  };
}

// -------------------------------------------------------
//
// CHANGELOG
//
// -------------------------------------------------------
// Version 2022040301
// - INITIAL VERSION
//
// -------------------------------------------------------
//
// Version 2022082901
// - Removed sleep log specific question
// - Added what helped and didn't help qeustions to the beginning
// - Rephrased sleep hygeine as sleep habits
// - Added a question about how well you were able to follow healthy sleep habits
// - Removed question about sleep habits and sleep log since it's included in beginning 2 questions

// -------
// Version 2023061401
// Question 1 - move prescription sleep medication to the top
// Question 1&2 - remove sleep coaching for now
// Question 3 - grogginess next day
// Question 3 - add "other"
// Question 4 - clarify "what were you hoping a new medication would do?"
